import Chat from './Chat';
import Compare from './Compare';
import Translate from './Translate';
import Models from './Models';

const OciAiTest = {
  Chat,
  Compare,
  Translate,
  Models,
};

export default OciAiTest;